import { MembershipsSpotifyIntegrationsApiClient } from '@fourthwall/services/dist/MembershipsSpotifyIntegrationsApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useSyncPodcastMutation = createMutationHook(
  MembershipsSpotifyIntegrationsApiClient.syncPodcast,
  {
    mutationKey: ['syncPodcast'],
  },
)
